"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SATELLITE_MOVE_WARNING_DAYS = exports.APPROACHING_WINDOW_DAYS = void 0;
exports.limitKey = limitKey;
function limitKey(rule) {
    return `${rule.areaType}:${rule.limit.kind}`;
}
exports.APPROACHING_WINDOW_DAYS = 30; // TIME limits; pending team confirm
// The nightly deadline-flag sweep's satellite warning threshold. Deliberately
// narrower than the chip's move-window treatment, which shows APPROACHING for
// the whole 3-day window: an alert one day out, a visual cue immediately.
exports.SATELLITE_MOVE_WARNING_DAYS = 1; // decision log #15
//# sourceMappingURL=types.js.map